import React from "react";
import Lottie from "lottie-react";
import animationData from "./page-loader.json";
import "./PageLoader.css"

const PageLoader = () => {
    return (
        <div className="general-page-loader">
            <Lottie
                animationData={animationData}
                loop={true}
                className="lottie-animation"
            />
        </div>
    );
};

export default PageLoader;
